import React from 'react';

import classNames from 'classnames';
import {Container} from 'reactstrap';

import {COMPANY_STATUSES, VIEWPORT_WIDTHS} from 'configs';
import {ENABLE_AB_CONTACT_US} from 'configs/enable-features';
import {useViewport} from 'contexts/ViewportContext';

import ABHelmet from './ABHelmet';
import ABHero from './ABHero';
import ABDescription from './ABDescription';
import ABComplianceStatus from './ABComplianceStatus';
import ABCertificationBody from './ABCertificationBody';
import ABStandards from './ABStandards';
import ABKeyLocations from './ABKeyLocations';
import ABContact from './ABContact';

import useGetAB from './useGetAB';
import {useAuth} from 'contexts/AuthContext';

import {get} from 'lodash';
import styles from './styles.module.scss';

function AccreditationBody() {
  const abProps = useGetAB();
  const {isAuth, isMainAccount, account} = useAuth();
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS.xl;
  const isCompanySuspended =
    get(account, 'company.company_status') === COMPANY_STATUSES.suspended;

  return (
    <Container className={classNames(isMobile ? 'px-3 py-0' : 'p-0')}>
      <ABHelmet {...abProps} />

      <div className={styles['header']}>Accreditation Body</div>
      <hr className={styles['hr--thickness-two']} />

      <ABHero {...abProps} />
      <hr className={styles['hr--thickness-one']} />

      <ABDescription {...abProps} />
      <hr className={styles['hr--thickness-one']} />

      <ABComplianceStatus {...abProps} />
      <hr className={styles['hr--thickness-one']} />

      <ABCertificationBody />
      <hr className={styles['hr--thickness-one']} />

      <ABStandards />
      <hr className={styles['hr--thickness-one']} />

      <ABKeyLocations />

      {ENABLE_AB_CONTACT_US &&
        (isAuth && isMainAccount ? !isCompanySuspended : true) && (
          <>
            <hr className={styles['hr--thickness-one']} />

            <ABContact />
          </>
        )}
    </Container>
  );
}

export default AccreditationBody;
